import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NewslettersService } from '@common/core/services';
import { EBitfUiMessageType } from '@common/enums';
import { IBitfToastData } from '@interfaces';
import { bitfMarkAllFormControlsAsTouched } from '@common/libs/bitforce/utils/bitf-form.utils';
import { bitfValidateEmail } from '@common/libs/bitforce/validators/bitf-email.validator';
import { ToastMessagesService } from '@web/core/services';
import { TranslateService } from '@ngx-translate/core';
import { BitfErrorHandlerService } from '@common/libs/bitforce/core/services/error-handler/bitf-error-handler.service';

@Component({
  selector: 'cci-newsletter',
  templateUrl: './newsletter.component.html',
  styleUrls: ['./newsletter.component.scss'],
})
export class NewsletterComponent implements OnInit {
  @Output() subscribed = new EventEmitter();
  newsletterForm: FormGroup;
  isMessageSent = false;

  constructor(
    private formBuilder: FormBuilder,
    private newsletterService: NewslettersService,
    private toastMessageService: ToastMessagesService,
    private translateService: TranslateService,
    private bitfErrorHandlerService: BitfErrorHandlerService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  onSubmit() {
    bitfMarkAllFormControlsAsTouched(this.newsletterForm);
    const formValue = this.newsletterForm.value;
    if (!formValue.newsletterSubscription) {
      this.toastMessageService.show({
        type: EBitfUiMessageType.ERROR,
        message: this.translateService.instant('COMMON.LABEL.YOU_HAVE_TO_ACCEPT_NEWSLETTER_SUBSCRIPTION'),
      } as IBitfToastData);
      return;
    }

    if (this.newsletterForm.valid) {
      this.newsletterService.post({ body: { email: formValue.email?.toLowerCase().trim() } }).subscribe(
        () => {
          this.subscribed.emit();
          this.isMessageSent = true;
          this.newsletterForm.reset();
        },
        error => {
          this.bitfErrorHandlerService.handleError(error);
          this.toastMessageService.show({
            type: EBitfUiMessageType.ERROR,
            message: this.translateService.instant('COMMON.LABEL.EMAIL_ALREADY_SUBSCRIBED_OR_INVALID'),
          } as IBitfToastData);
        }
      );
    } else {
      this.toastMessageService.show({
        type: EBitfUiMessageType.SUCCESS,
        message: this.translateService.instant('COMMON.LABEL.INVALID_EMAIL'),
      } as IBitfToastData);
    }
  }

  private initForm() {
    this.newsletterForm = this.formBuilder.group({
      email: ['', [bitfValidateEmail, Validators.required]],
      newsletterSubscription: [true],
    });
  }
}
